import cx from 'classnames';
import { HeaderDesktopMenuDrawerProps, HeaderDesktopMenuLinkProps } from '../HeaderDesktopMenu';
import { HeaderDesktopDrawerTrigger } from './HeaderDesktopDrawerTrigger';
import { HeaderDesktopMenuLink } from './HeaderDesktopMenuLink';

type CenterMenuColumnProps = {
  desktopMenu: (HeaderDesktopMenuDrawerProps | HeaderDesktopMenuLinkProps)[];
  invert?: boolean;
  isHeaderScrolled: boolean;
  onCloseAllMenus: () => void;
  onClickMenuDrawer: (index: number) => () => void;
  onMouseEnterMenuDrawer: (index: number) => () => void;
  activeDesktopHeaderMenuIndex: number;
}

export const CenterMenuColumn = ({
  desktopMenu,
  invert,
  isHeaderScrolled,
  onCloseAllMenus,
  onClickMenuDrawer,
  onMouseEnterMenuDrawer,
  activeDesktopHeaderMenuIndex,
}: CenterMenuColumnProps) =>
  <div className="lg:col-span-4 2xl:col-span-6 hidden lg:flex lg:justify-center">
    <ul className="flex 2xl:gap-1 justify-center items-center transition-opacity duration-300 ease-appear text-blue-900">
      {desktopMenu.map((menuColumn, index) => {
        switch (menuColumn.type) {
          case 'link':
            return (
              <div key={`header-desktop-menu-link-${index}`}>
                <HeaderDesktopMenuLink
                  {...menuColumn}
                  invert={invert}
                  scrolled={isHeaderScrolled}
                  onMouseEnter={onCloseAllMenus}
                  onClick={onCloseAllMenus}
                />
              </div>
            );
          case 'drawer':
            return (
              <div key={`header-desktop-menu-drawer-${index}`}>
                <HeaderDesktopDrawerTrigger
                  invert={invert}
                  scrolled={isHeaderScrolled}
                  title={menuColumn.title}
                  onMouseEnter={onMouseEnterMenuDrawer(index)}
                  onClick={onClickMenuDrawer(index)}
                  className={cx({
                    active: index === activeDesktopHeaderMenuIndex,
                  })}
                />
              </div>
            );
          default:
            return null;
        }
      })}
    </ul>
  </div>
